<template>
  <li class="w-72 shrink-0 cursor-pointer relative">
    <div
      class="relative overflow-hidden rounded-lg border border-gray-200 h-[17.813em] group"
      :class="selected && '!border-blue-600'"

      @mouseenter="showPreview"
      @mouseleave="hidePreview"
    >
      <iframe
        v-if="(showingPreview || loaded) && !preview_src"

        class="origin-top-left"
        width="1450"
        height="1100"
        :src="link + '?preview_config=' + encodedConfig"
        style='transform: scale(.2, .2)'

        @load="loaded = true"
      ></iframe>
      <img v-else-if="preview_src" :src="preview_src" class="w-full h-auto">

      <transition v-if="!loading && !preview_src"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"

        mode="out-in"
      >
        <div v-if="!showingPreview && !loaded" class="absolute duration-200 w-full h-full z-20 top-0 left-0 bg-white flex justify-center items-center flex-col" key="asht">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <h4 class="mt-2 font-bold">Hover to preview</h4>
        </div>
        <div v-else-if="showingPreview && !loaded" class="absolute text-primary duration-200 w-full h-full z-20 top-0 left-0 bg-white flex justify-center items-center flex-col" key="athas">
          <svg class="animate-spin -ml-1 mr-3 h-12 w-12 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          <h4 class="mt-2 font-bold">Loading preview...</h4>
        </div>
      </transition>

      <div class="w-full h-full absolute left-0 top-0 ske"></div>

      <span v-if="!loading" class="z-40 absolute overflow-hidden left-0 top-0 top-0 ml-2 mt-2 w-5 h-5 rounded-full border border-gray-300 inline-block" :class="selected && '!border-blue-600'">
        <span class="relative w-full h-full inline-block">
          <svg xmlns="http://www.w3.org/2000/svg" class="opacity-0 text-gray-300 scale-115 group-hover:opacity-100 duration-200 h-6 w-6 -mt-[1px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 absolute" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
          </svg>
          <svg v-if="selected" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-blue-600 scale-115 -mt-[1px] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 absolute" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
          </svg>
        </span>
      </span>

      <div v-if="!loading" class="absolute bottom-0 p-1 w-full left-0 w-full z-40">
        <transition
          enter-class="translate-y-[13em]"
          leave-class="translate-y-0"
          enter-to-class="translate-y-0"
          leave-to-class="translate-y-[13em]"
        >
          <button v-if="selected" class="bg-blue-600 hover:bg-blue-700 duration-200 ease-in-out space-x-2 flex items-center justify-center text-white p-2 w-full rounded-lg font-bold" @click="importTemplate">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path d="M7.707 10.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 11.586V6h5a2 2 0 012 2v7a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h5v5.586l-1.293-1.293zM9 4a1 1 0 012 0v2H9V4z" />
            </svg>
            <span class="-mt-0.5">
              Import template
            </span>
          </button>
        </transition>
      </div>
    </div>

    <div class="flex justify-between items-center mt-2">
      <h4 class="capitalize text-base font-bold ske">
        {{ name }}
      </h4>

      <div v-if="!loading && (adminEditingDefaultTemplate || normalUserEditingHisTemplate)" class="relative z-40" @click.stop v-click-outside="hideOptions" @click="showingOptions = true">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600 hover:text-gray-700 duration-200 cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
          <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
        </svg>

        <transition
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div v-if="showingOptions" class="origin-top-right duration-200 absolute right-0 bottom-full mt-2 w-64 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
            <div class="py-1" role="none">
              <span class="text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-6" @click='copyConfig'>
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                </svg>
                Copy encoded config
              </span>
            </div>
            <div class="py-1" role="none">
              <span class="text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-6" @click='$emit("overwrite-config", magento_config)'>
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                </svg>
                Overwrite config
              </span>
              <span class="text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-6" @click='$emit("edit-template")'>
                <!-- Heroicon name: solid/trash -->
                <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
                Edit template
              </span>
            </div>
            <div class="py-1" role="none">
              <span class="text-red-700 group flex items-center px-4 py-2 text-sm" role="menuitem" tabindex="-1" id="menu-item-6" @click='$emit("delete-template")'>
                <!-- Heroicon name: solid/trash -->
                <svg class="mr-3 h-5 w-5 text-red-400 group-hover:text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                </svg>
                Delete
              </span>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <h3 v-if="showPackage" class="capitalize font-semibold text-gray-600 ske">
      {{ loading ? "asht asht asht asht " : package_name }}
    </h3>
    <p class="line-clamp-4 mt-2">
      <span v-if="loading" class="ske">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labor
      </span>
      <span v-else>
        {{ description }}
      </span>
    </p>
  </li>
</template>

<script>

import { mapGetters } from "vuex"

export default {
  props: ['uid', 'name', 'description', 'preview_src', 'package_name', 'magento_config', 'defaultTemplate', 'loading', 'showPackage', 'selected'],
  computed: {
    ...mapGetters({
      isAdmin: 'isAdmin',
      link: 'editor/fullDomainLink',
      config: 'editor/config',
    }),

    adminEditingDefaultTemplate() {
      return this.isAdmin && this.defaultTemplate
    },
    normalUserEditingHisTemplate() {
      return !this.isAdmin && !this.defaultTemplate
    },
    previewConfig() {
      const config = this.magento_config && JSON.parse(this.magento_config)
      if (!config) return ""

      delete config.translations
      delete config.labels
      config.blocks_collection = { default: config.blocks_collection.default }
      return config
    },
    encodedConfig() {
      return encodeURIComponent(JSON.stringify(this.previewConfig))
    },
  },
  data() {
    return {
      showingPreview: false,
      showingOptions: false,
      loaded: false,
    }
  },
  async created() {
    try {
      await this.axios.get(this.link)
    } catch (err) {
      await this.$store.dispatch("toast/handleError", err)
    }
  },
  methods: {
    copyConfig() {
      navigator.clipboard.writeText(this.encodedConfig)
      this.$store.dispatch('toast/success', { message: "Successfully copied config!" })
    },
    importTemplate() {
      this.$store.commit("editor/startingFromScratch", false)
      this.$store.commit("editor/nonRecursiveConfig", JSON.parse(this.magento_config))
      this.$store.commit("editor/restart")

      this.$store.dispatch("toast/success", { message: "Successfully imported template!", description: "Keep in mind that you still need to save your configuration." })
      this.$emit("close-manager")
    },
    hideOptions() {
      this.showingOptions = false
    },
    showPreview() {
      this.showingPreview = true
    },
    hidePreview() {
      this.showingPreview = false
    },
  },
}

</script>
